import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

export const DatetimeCompactReadonlyStyled = styled.span.attrs<IStyledAttributes>(
  {
    "data-e2e": "datetime-compact-readonly-cell",
  },
)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 0;
  white-space: nowrap;
  color: ${blueGreyMui._700};
  text-align: center;

  .datetime-compact-readonly__date {
    font-size: 8px;
    line-height: 1.2;
    color: ${blueGreyMui._600};
    font-weight: 500;
    font-variant-numeric: tabular-nums;
  }

  .datetime-compact-readonly__time {
    font-size: 12px;
    line-height: 1.2;
    color: ${blueGreyMui._700};
    font-variant-numeric: tabular-nums;
    font-weight: 500;
  }
`;
